"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* Note this is a thin wrapper around React router Link */
var Link = function Link(_ref) {
  var to = _ref.to,
    as = _ref.as,
    replace = _ref.replace,
    text = _ref.text,
    strict = _ref.strict;
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: to,
    as: as,
    replace: !!replace,
    strict: !!strict
  }, text);
};
exports.Link = Link;